import React       from 'react';
import i18n        from '../../i18n';
import Layout      from '../../components/Layout';
import Paper       from "@material-ui/core/Paper/Paper";
import ContactForm from "../../components/Contacts/ContactForm";
import Toolbar     from "../../components/Toolbar/Toolbar";
import CardContent from "@material-ui/core/CardContent/CardContent";
import {get}       from "lodash";
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';

const ContactsCreate = ({classes, contactType, formUrl, preselectedHouse, redirectAfterSubmit, isCreateSelf = false, isEmployee, newAddressNumbers , _user }) => {
    let transConfig = { // clean contactType-Translation
        'craft' : 'company',
        'tenant': 'contact_person',
        'person': 'contact_person',
    };
    let trans       = get(transConfig, contactType, contactType);
    let title       = i18n.get('contacts.new_' + trans);

    const [parentId, setParentId] =  useQueryParam('parent_id', NumberParam);
    const [keyContactId, setKeyContactId] =  useQueryParam('key_contact_id', NumberParam);

    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get(title)}
            />

            <Paper>
                <CardContent>
                    <ContactForm
                        contactType={contactType}
                        formUrl={formUrl}
                        values={preselectedHouse}
                        isEdit={false}
                        isCreateSelf={isCreateSelf}
                        redirectAfterSubmit={redirectAfterSubmit}
                        parentId={parentId}
                        keyContactId={keyContactId}
                        isEmployee={isEmployee}
                        newAddressNumbers={newAddressNumbers}
                    />
                </CardContent>
            </Paper>
        </Layout>
    );
}

export default ContactsCreate;
